<template>
    <div class="stat-card">
        <div class="text">
            <p class="label">{{ title }}</p>
            <h2 class="value">{{ value }}</h2>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        value: {
            type: Number,
            required: false,
            default: 0
        }
    }
};
</script>
